import { render, staticRenderFns } from "./ProductNameCell.vue?vue&type=template&id=1d9e12a6&scoped=true"
import script from "./ProductNameCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductNameCell.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductNameCell.vue?vue&type=style&index=0&id=1d9e12a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e12a6",
  null
  
)

export default component.exports